import { createContext, useContext } from 'react';

// When enabled, dirty fields show a yellow underline and a revert-to-default button.
// Kept off by default so create forms (where every field differs from defaults) stay quiet.
export const FieldRevertContext = createContext<boolean>(false);

export const useIsFieldRevertEnabled = (): boolean => useContext(FieldRevertContext);
